import { RootState } from '../../../applicationStore';
import { SuppliersState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getSuppliersState = (state: RootState): SuppliersState =>
  state.suppliers;

export const getSuppliersLoader = createSelector(
  getSuppliersState,
  (state): boolean => state.loading,
);

export const getSuppliersData = createSelector(
  getSuppliersState,
  (state): SuppliersState['data'] | null => state?.data || [],
);
